export default "__VITE_ASSET__76075ef5__"